import React, { ReactElement } from "react";
import { IconSvg } from "../../icon/icon-svg";

export const IconResizeCorner = ({ ...svgAttrs }): ReactElement => (
  <IconSvg {...svgAttrs}>
    <g fill="#ccc">
      <circle cx="21.7" cy="2.3" r="2.3" />
      <circle cx="12" cy="12" r="2.3" />
      <circle cx="21.7" cy="12" r="2.3" />
      <circle cx="21.7" cy="21.7" r="2.3" />
      <circle cx="12" cy="21.7" r="2.3" />
      <circle cx="2.3" cy="21.7" r="2.3" />
    </g>
  </IconSvg>
);
